export class EmployeeDeptRequest{
    employeeDept:string;
    
    constructor(employeeDept:string){
        this.employeeDept = employeeDept;
    }
}